import * as React from 'react'
import { Icon } from '@blueprintjs/core'

interface Props {
  path: string
}

export const SvgIcon: React.FC<Props> = props => {
  const size = 16

  return (
    <>
      <Icon
        icon={
          <span className="bp3-icon">
            <svg width={size} height={size}>
              <image href={props.path} width={size} height={size} />
            </svg>
          </span>
        }
      />
    </>
  )
}
